// Helper function to sort mappings by category and Hebrew label
const sortMappings = (mappings) => {
  return mappings.sort((a, b) => {
    // Extract categories (text before period if exists)
    const hasValueA = a.value.includes(".");
    const hasValueB = b.value.includes(".");

    // If one has category and other doesn't, non-category comes first
    if (hasValueA !== hasValueB) {
      return hasValueA ? 1 : -1;
    }

    const categoryA = a.value.split(".")[0];
    const categoryB = b.value.split(".")[0];

    // If both have categories, compare them
    if (hasValueA && hasValueB && categoryA !== categoryB) {
      return categoryA.localeCompare(categoryB);
    }

    // If categories are same or both don't have categories, compare Hebrew labels
    return a.label.localeCompare(b.label, "he");
  });
};

export const entityFieldMappings = {
  patient: sortMappings([
    {
      value: "absences",
      label: "היעדרויות",
    },
    {
      value: "address_details",
      label: "כתובת מלאה",
    },
    {
      value: "address_instructions.entrance",
      label: "כניסה (הוראות כתובת)",
    },
    {
      value: "address_instructions.floor",
      label: "קומה (הוראות כתובת)",
    },
    {
      value: "address_instructions.has_elevator",
      label: "יש מעלית (הוראות כתובת)",
    },
    {
      value: "address_instructions.required_code",
      label: "קוד נדרש (הוראות כתובת)",
    },
    {
      value: "address.apartment_number",
      label: "מספר דירה (כתובת)",
    },
    {
      value: "address.city",
      label: "עיר (כתובת)",
    },
    {
      value: "address.house_number",
      label: "מספר בית (כתובת)",
    },
    {
      value: "address.postal_code",
      label: "מיקוד (כתובת)",
    },
    {
      value: "address.street",
      label: "רחוב (כתובת)",
    },
    {
      value: "apotropus.address",
      label: "כתובת (אפוטרופוס)",
    },
    {
      value: "apotropus.email",
      label: "אימייל (אפוטרופוס)",
    },
    {
      value: "apotropus.exists",
      label: "קיים (אפוטרופוס)",
    },
    {
      value: "apotropus.fax_number",
      label: "מספר פקס (אפוטרופוס)",
    },
    {
      value: "apotropus.mobile_number",
      label: "מספר נייד (אפוטרופוס)",
    },
    {
      value: "apotropus.name",
      label: "שם (אפוטרופוס)",
    },
    {
      value: "apotropus.phone_number",
      label: "מספר טלפון (אפוטרופוס)",
    },
    {
      value: "assets",
      label: "נכסים",
    },
    {
      value: "assigned_by",
      label: "הוקצה על ידי",
    },
    {
      value: "avatar_url",
      label: "כתובת תמונת פרופיל",
    },
    {
      value: "birthday",
      label: "תאריך לידה",
    },
    {
      value: "branch",
      label: "סניף",
    },
    {
      value: "branch_extension_id",
      label: "מזהה (שלוחה)",
    },
    {
      value: "branch_extension.branch",
      label: "סניף (שלוחה)",
    },
    {
      value: "branch_extension.branch_id",
      label: "מזהה סניף (שלוחה)",
    },
    {
      value: "branch_extension.id",
      label: "מזהה (שלוחה)",
    },
    {
      value: "branch_extension.name",
      label: "שם (שלוחה)",
    },
    {
      value: "branch_extension.number",
      label: "מספר (שלוחה)",
    },
    {
      value: "branch_id",
      label: "מזהה סניף",
    },
    {
      value: "care_demands",
      label: "דרישות טיפול",
    },
    {
      value: "categories",
      label: "קטגוריות",
    },
    {
      value: "childless",
      label: "ללא ילדים",
    },
    {
      value: "cleaning_hours_per_day",
      label: "שעות ניקיון ביום",
    },
    {
      value: "contact_info.agree_to_receive_email",
      label: "הסכמה לקבלת אימייל (פרטי התקשרות)",
    },
    {
      value: "contact_info.agree_to_receive_sms",
      label: "הסכמה לקבלת SMS (פרטי התקשרות)",
    },
    {
      value: "contact_info.email",
      label: "אימייל (פרטי התקשרות)",
    },
    {
      value: "contact_info.fax_number",
      label: "מספר פקס (פרטי התקשרות)",
    },
    {
      value: "contact_info.mailbox_number",
      label: "מספר תיבת דואר (פרטי התקשרות)",
    },
    {
      value: "contact_info.mobile_number",
      label: "מספר נייד (פרטי התקשרות)",
    },
    {
      value: "contact_info.phone_number",
      label: "מספר טלפון (פרטי התקשרות)",
    },
    {
      value: "contact_info.phone_number2",
      label: "מספר טלפון נוסף (פרטי התקשרות)",
    },
    {
      value: "country",
      label: "מדינה",
    },
    {
      value: "created_at",
      label: "נוצר בתאריך",
    },
    {
      value: "crm_events",
      label: "אירועי CRM",
    },
    {
      value: "crm_tasks",
      label: "משימות CRM",
    },
    {
      value: "current_date",
      label: "תאריך נוכחי",
    },
    {
      value: "days_in_day_center",
      label: "ימים במרכז יום",
    },
    {
      value: "emergency_service_status",
      label: "סטטוס שירות חירום",
    },
    {
      value: "emergency_service_status_id",
      label: "מזהה סטטוס שירות חירום",
    },
    {
      value: "emergency.bound_to_bed",
      label: "מרותק למיטה (חירום)",
    },
    {
      value: "emergency.exported_at",
      label: "יוצא בתאריך (חירום)",
    },
    {
      value: "emergency.gudance_date",
      label: "תאריך הדרכה (חירום)",
    },
    {
      value: "emergency.has_chair_wheel",
      label: "יש כיסא גלגלים (חירום)",
    },
    {
      value: "emergency.has_dialysis_machine",
      label: "יש מכונת דיאליזה (חירום)",
    },
    {
      value: "emergency.has_emergency_details",
      label: "יש פרטי חירום",
    },
    {
      value: "emergency.has_oxigen_generator",
      label: "יש מחולל חמצן (חירום)",
    },
    {
      value: "emergency.last_updated_by_file",
      label: "עודכן לאחרונה על ידי קובץ (חירום)",
    },
    {
      value: "emergency.last_updated_manually",
      label: "עודכן לאחרונה ידנית (חירום)",
    },
    {
      value: "emergency.staris_to_street",
      label: "מדרגות לרחוב (חירום)",
    },
    {
      value: "emergency.way_of_communication",
      label: "אמצעי תקשורת (חירום)",
    },
    {
      value: "emergency.way_of_communication_id",
      label: "מזהה אמצעי תקשורת (חירום)",
    },
    {
      value: "employment_license_number",
      label: "מספר רישיון עבודה",
    },
    {
      value: "family_status_id",
      label: "מזהה סטטוס משפחתי",
    },
    {
      value: "first_name",
      label: "שם פרטי",
    },
    {
      value: "foreign_corporation_end_at",
      label: "תאריך סיום תאגיד זר",
    },
    {
      value: "foreign_corporation_id",
      label: "מזהה תאגיד זר",
    },
    {
      value: "foreign_corporation_registred_at",
      label: "תאריך רישום תאגיד זר",
    },
    {
      value: "foreign_worker_associations",
      label: "עמותות עובדים זרים",
    },
    {
      value: "full_name",
      label: "שם מלא",
    },
    {
      value: "gender_id",
      label: "מזהה מגדר",
    },
    {
      value: "geo",
      label: "מיקום גיאוגרפי",
    },
    {
      value: "has_employment_license",
      label: "יש רישיון עבודה",
    },
    {
      value: "has_panic_button",
      label: "יש כפתור מצוקה",
    },
    {
      value: "has_shelter_area",
      label: "יש אזור מקלט",
    },
    {
      value: "has_temporary_address",
      label: "כתובת זמנית",
    },
    {
      value: "has_time_clock",
      label: "יש שעון זמן",
    },
    {
      value: "holocast_survivor",
      label: "ניצול שואה",
    },
    {
      value: "hospitalizations",
      label: "אשפוזים",
    },
    {
      value: "house_visit_comments",
      label: "הערות ביקור בית",
    },
    {
      value: "house_visit_settings",
      label: "הגדרות ביקור בית",
    },
    {
      value: "id",
      label: "מזהה",
    },
    {
      value: "immigration_date",
      label: "תאריך הגירה",
    },
    {
      value: "languages",
      label: "שפות",
    },
    {
      value: "laundary",
      label: "כביסה",
    },
    {
      value: "live_alone",
      label: "חי לבד",
    },
    {
      value: "live_in_institution",
      label: "חי במוסד",
    },
    {
      value: "local_id_number",
      label: "מספר זיהוי מקומי",
    },
    {
      value: "medical_info.clinic_name",
      label: "שם מרפאה (מידע רפואי)",
    },
    {
      value: "medical_info.clinic_phone",
      label: "טלפון מרפאה (מידע רפואי)",
    },
    {
      value: "medical_info.deseases",
      label: "מחלות (מידע רפואי)",
    },
    {
      value: "medical_info.diagnoses",
      label: "אבחנות (מידע רפואי)",
    },
    {
      value: "medical_info.doctor_name",
      label: "שם רופא (מידע רפואי)",
    },
    {
      value: "medical_info.health_fund_id",
      label: "מזהה קופת חולים (מידע רפואי)",
    },
    {
      value: "medical_info.limitations",
      label: "מגבלות (מידע רפואי)",
    },
    {
      value: "medical_info.medicines",
      label: "תרופות (מידע רפואי)",
    },
    {
      value: "medical_info.psychiatrist_name",
      label: "שם פסיכיאטר (מידע רפואי)",
    },
    {
      value: "medical_info.psychiatrist_phone",
      label: "טלפון פסיכיאטר (מידע רפואי)",
    },
    {
      value: "non_available_hours",
      label: "שעות לא זמינות",
    },
    {
      value: "num_people_at_home",
      label: "מספר אנשים בבית",
    },
    {
      value: "nursing_home",
      label: "בית אבות",
    },
    {
      value: "nursing_home_id",
      label: "מזהה בית אבות",
    },
    {
      value: "opportunity_status_id",
      label: "מזהה סטטוס הזדמנות",
    },
    {
      value: "opportunity_status.id",
      label: "מזהה סטטוס הזדמנות",
    },
    {
      value: "opportunity_status.is_completed",
      label: "הושלם (סטטוס הזדמנות)",
    },
    {
      value: "opportunity_status.is_default",
      label: "ברירת מחדל (סטטוס הזדמנות)",
    },
    {
      value: "opportunity_status.name",
      label: "שם סטטוס הזדמנות",
    },
    {
      value: "opportunity_status.sort_order",
      label: "סדר מיון (סטטוס הזדמנות)",
    },
    {
      value: "passing_date",
      label: "תאריך פטירה",
    },
    {
      value: "payments.address",
      label: "כתובת (תשלומים)",
    },
    {
      value: "payments.city",
      label: "עיר (תשלומים)",
    },
    {
      value: "payments.debit_account_number",
      label: "מספר חשבון חיוב (תשלומים)",
    },
    {
      value: "payments.email",
      label: "אימייל (תשלומים)",
    },
    {
      value: "payments.name",
      label: "שם (תשלומים)",
    },
    {
      value: "payments.paid_by_relative",
      label: "תשלום על ידי קרוב משפחה (תשלומים)",
    },
    {
      value: "payments.postal_code",
      label: "מיקוד (תשלומים)",
    },
    {
      value: "payments.self_payment",
      label: "תשלום עצמי (תשלומים)",
    },
    {
      value: "references",
      label: "הפניות",
    },
    {
      value: "registered_at",
      label: "תאריך רישום",
    },
    {
      value: "registered_by",
      label: "נרשם על ידי",
    },
    {
      value: "relative_employees",
      label: "עובדים קרובים",
    },
    {
      value: "relatives",
      label: "קרובי משפחה",
    },
    {
      value: "religion_id",
      label: "מזהה דת",
    },
    {
      value: "service_area",
      label: "אזור שירות",
    },
    {
      value: "service_area_id",
      label: "מזהה אזור שירות",
    },
    {
      value: "service_started_at",
      label: "תאריך תחילת שירות",
    },
    {
      value: "shelter_in_building",
      label: "מקלט בבניין",
    },
    {
      value: "staff_worker_in_charge",
      label: "עובד אחראי",
    },
    {
      value: "staff_worker_in_charge_id",
      label: "מזהה עובד אחראי",
    },
    {
      value: "status_id",
      label: "מזהה סטטוס",
    },
    {
      value: "subproject_id",
      label: "מזהה (תת-פרויקט)",
    },
    {
      value: "subproject.description",
      label: "תיאור (תת-פרויקט)",
    },
    {
      value: "subproject.id",
      label: "מזהה (תת-פרויקט)",
    },
    {
      value: "subproject.name",
      label: "שם (תת-פרויקט)",
    },
    {
      value: "subproject.number",
      label: "מספר (תת-פרויקט)",
    },
    {
      value: "surename",
      label: "שם משפחה",
    },
    {
      value: "temporary_address",
      label: "כתובת זמנית",
    },
    {
      value: "temporary_address_details",
      label: "פרטי כתובת זמנית",
    },
    {
      value: "updated_at",
      label: "עודכן בתאריך",
    },
    {
      value: "use_diapers",
      label: "שימוש בחיתולים",
    },
    {
      value: "use_temporary_address_for_service",
      label: "שימוש בכתובת זמנית לשירות",
    },
  ]),

  employee: sortMappings([
    {
      value: "absences",
      label: "היעדרויות",
    },
    {
      value: "accounting_info.department_id",
      label: "מזהה מחלקה (מידע חשבונאי)",
    },
    {
      value: "accounting_info.department.code",
      label: "קוד מחלקה (מידע חשבונאי)",
    },
    {
      value: "accounting_info.department.description",
      label: "תיאור מחלקה (מידע חשבונאי)",
    },
    {
      value: "accounting_info.department.id",
      label: "מזהה מחלקה (מידע חשבונאי)",
    },
    {
      value: "accounting_info.department.name",
      label: "שם מחלקה (מידע חשבונאי)",
    },
    {
      value: "accounting_info.number",
      label: "מספר חשבון (מידע חשבונאי)",
    },
    {
      value: "active",
      label: "פעיל",
    },
    {
      value: "active_branches",
      label: "סניפים פעילים",
    },
    {
      value: "address_details",
      label: "כתובת מלאה",
    },
    {
      value: "address.apartment_number",
      label: "מספר דירה (כתובת)",
    },
    {
      value: "address.city",
      label: "עיר (כתובת)",
    },
    {
      value: "address.house_number",
      label: "מספר בית (כתובת)",
    },
    {
      value: "address.postal_code",
      label: "מיקוד (כתובת)",
    },
    {
      value: "address.street",
      label: "רחוב (כתובת)",
    },
    {
      value: "agree_to_receive_email",
      label: "הסכמה לקבלת אימייל",
    },
    {
      value: "agree_to_receive_sms",
      label: "הסכמה לקבלת SMS",
    },
    {
      value: "assets",
      label: "נכסים",
    },
    {
      value: "avatar_url",
      label: "כתובת תמונת פרופיל",
    },
    {
      value: "bank_acccount.bank_id",
      label: "מזהה בנק (חשבון בנק)",
    },
    {
      value: "bank_acccount.bank_name",
      label: "שם הבנק (חשבון בנק)",
    },
    {
      value: "bank_acccount.branch_id",
      label: "מזהה סניף (חשבון בנק)",
    },
    {
      value: "bank_acccount.branch_name",
      label: " שם הסניף (חשבון בנק)",
    },
    {
      value: "bank_acccount.number",
      label: "מספר חשבון (חשבון בנק)",
    },
    {
      value: "birthday",
      label: "תאריך לידה",
    },
    {
      value: "branch_active",
      label: "סניף פעיל",
    },
    {
      value: "care_demands",
      label: "דרישות טיפול",
    },
    {
      value: "care_giver",
      label: "מטפל",
    },
    {
      value: "certifications",
      label: "הסמכות",
    },
    {
      value: "certified",
      label: "מוסמך",
    },
    {
      value: "certified_courses",
      label: "קורסים מוסמכים",
    },
    {
      value: "children",
      label: "ילדים",
    },
    {
      value: "contact_info.agree_to_receive_email",
      label: "הסכמה לקבלת אימייל (פרטי התקשרות)",
    },
    {
      value: "contact_info.agree_to_receive_sms",
      label: "הסכמה לקבלת SMS (פרטי התקשרות)",
    },
    {
      value: "contact_info.email",
      label: "אימייל (פרטי התקשרות)",
    },
    {
      value: "contact_info.fax_number",
      label: "מספר פקס (פרטי התקשרות)",
    },
    {
      value: "contact_info.mailbox_number",
      label: "מספר תיבת דואר (פרטי התקשרות)",
    },
    {
      value: "contact_info.mobile_number",
      label: "מספר נייד (פרטי התקשרות)",
    },
    {
      value: "contact_info.phone_number",
      label: "מספר טלפון (פרטי התקשרות)",
    },
    {
      value: "contact_info.phone_number2",
      label: "מספר טלפון נוסף (פרטי התקשרות)",
    },
    {
      value: "controller",
      label: "מפקח",
    },
    {
      value: "created_at",
      label: "נוצר בתאריך",
    },
    {
      value: "crm_events",
      label: "אירועי CRM",
    },
    {
      value: "crm_tasks",
      label: "משימות CRM",
    },
    {
      value: "current_date",
      label: "תאריך נוכחי",
    },
    {
      value: "daily_transportation_cost_id",
      label: "מזהה עלות תחבורה יומית",
    },
    {
      value: "education_id",
      label: "מזהה השכלה",
    },
    {
      value: "employee_type_id",
      label: "מזהה סוג עובד",
    },
    {
      value: "exported_at",
      label: "יוצא בתאריך",
    },
    {
      value: "family_status",
      label: "סטטוס משפחתי",
    },
    {
      value: "father_name",
      label: "שם אב",
    },
    {
      value: "finance_info.compensation_paid",
      label: "פיצוי שולם (מידע פיננסי)",
    },
    {
      value: "finance_info.exported_to_finance",
      label: "יוצא לפיננסים (מידע פיננסי)",
    },
    {
      value: "finance_info.has_pension",
      label: "יש פנסיה (מידע פיננסי)",
    },
    {
      value: "finance_info.pay_via_bank",
      label: "תשלום דרך בנק (מידע פיננסי)",
    },
    {
      value: "finance_info.pension_details",
      label: "פרטי פנסיה (מידע פיננסי)",
    },
    {
      value: "first_name",
      label: "שם פרטי",
    },
    {
      value: "foreign_worker_associations",
      label: "עמותות עובדים זרים",
    },
    {
      value: "foreign.address",
      label: "כתובת (מידע זר)",
    },
    {
      value: "foreign.bank_account.address",
      label: "כתובת (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.branch_name",
      label: "שם סניף (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.branch_symbol",
      label: "סמל סניף (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.country",
      label: "מדינה (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.first_name",
      label: "שם פרטי (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.name",
      label: "שם (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.number",
      label: "מספר חשבון (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.surname",
      label: "שם משפחה (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.swift_code",
      label: "קוד SWIFT (חשבון בנק זר)",
    },
    {
      value: "foreign.bank_account.symbol",
      label: "סמל (חשבון בנק זר)",
    },
    {
      value: "foreign.country_enter_date",
      label: "תאריך כניסה למדינה (מידע זר)",
    },
    {
      value: "foreign.current_corporation_id",
      label: "מזהה תאגיד נוכחי (מידע זר)",
    },
    {
      value: "foreign.current_corporation_registry_date",
      label: "תאריך רישום תאגיד נוכחי (מידע זר)",
    },
    {
      value: "foreign.deposit_acccount.bank_id",
      label: "מזהה בנק (חשבון פיקדון זר)",
    },
    {
      value: "foreign.deposit_acccount.branch_id",
      label: "מזהה סניף (חשבון פיקדון זר)",
    },
    {
      value: "foreign.deposit_acccount.number",
      label: "מספר חשבון (חשבון פיקדון זר)",
    },
    {
      value: "foreign.employment_license_expiration",
      label: "תאריך תפוגת רישיון עבודה (מידע זר)",
    },
    {
      value: "foreign.employment_license_number",
      label: "מספר רישיון עבודה (מידע זר)",
    },
    {
      value: "foreign.exited_country_at",
      label: "תאריך יציאה מהמדינה (מידע זר)",
    },
    {
      value: "foreign.father_name",
      label: "שם אב (מידע זר)",
    },
    {
      value: "foreign.file_issued",
      label: "קובץ הונפק (מידע זר)",
    },
    {
      value: "foreign.file_issued_at",
      label: "תאריך הנפקת קובץ (מידע זר)",
    },
    {
      value: "foreign.first_name",
      label: "שם פרטי (מידע זר)",
    },
    {
      value: "foreign.has_assignment_letter",
      label: "יש מכתב משימה (מידע זר)",
    },
    {
      value: "foreign.insurance_company_id",
      label: "מזהה חברת ביטוח (מידע זר)",
    },
    {
      value: "foreign.insurance_company.description",
      label: "תיאור חברת ביטוח (מידע זר)",
    },
    {
      value: "foreign.insurance_company.id",
      label: "מזהה חברת ביטוח (מידע זר)",
    },
    {
      value: "foreign.insurance_company.name",
      label: "שם חברת ביטוח (מידע זר)",
    },
    {
      value: "foreign.interior_ministry_case_number",
      label: "מספר תיק במשרד הפנים (מידע זר)",
    },
    {
      value: "foreign.medical_insurance_expired_at",
      label: "תאריך תפוגת ביטוח רפואי (מידע זר)",
    },
    {
      value: "foreign.mother_name",
      label: "שם אם (מידע זר)",
    },
    {
      value: "foreign.origin_country",
      label: "מדינת מוצא (מידע זר)",
    },
    {
      value: "foreign.partner_in_country",
      label: "שותף במדינה (מידע זר)",
    },
    {
      value: "foreign.passport_expired_at",
      label: "תאריך תפוגת דרכון (מידע זר)",
    },
    {
      value: "foreign.passport_number",
      label: "מספר דרכון (מידע זר)",
    },
    {
      value: "foreign.previous_corporation_id",
      label: "מזהה תאגיד קודם (מידע זר)",
    },
    {
      value: "foreign.registered_in_employer_service",
      label: "רשום בשירות מעסיקים (מידע זר)",
    },
    {
      value: "foreign.surename",
      label: "שם משפחה (מידע זר)",
    },
    {
      value: "foreign.tourist_with_license",
      label: "תייר עם רישיון (מידע זר)",
    },
    {
      value: "foreign.visa_expired_at",
      label: "תאריך תפוגת ויזה (מידע זר)",
    },
    {
      value: "foreign.visa_number",
      label: "מספר ויזה (מידע זר)",
    },
    {
      value: "full_name",
      label: "שם מלא",
    },
    {
      value: "full_name_english",
      label: "שם מלא באנגלית",
    },
    {
      value: "gender_id",
      label: "מזהה מגדר",
    },
    {
      value: "geo.address_line",
      label: "שורת כתובת (מיקום גיאוגרפי)",
    },
    {
      value: "geo.latitude",
      label: "קו רוחב (מיקום גיאוגרפי)",
    },
    {
      value: "geo.longtitude",
      label: "קו אורך (מיקום גיאוגרפי)",
    },
    {
      value: "has_car",
      label: "יש רכב",
    },
    {
      value: "has_license",
      label: "יש רישיון",
    },
    {
      value: "has_other_income",
      label: "יש הכנסה נוספת",
    },
    {
      value: "health_fund",
      label: "קופת חולים",
    },
    {
      value: "health_fund_obj.name",
      label: "שם קופת חולים",
    },
    {
      value: "id",
      label: "מזהה",
    },
    {
      value: "immigration_date",
      label: "תאריך עלייה",
    },
    {
      value: "interested_in_several_scheduling",
      label: "מעוניין בתזמון מרובה",
    },
    {
      value: "israeli_resident",
      label: "תושב ישראלי",
    },
    {
      value: "languages",
      label: "שפות",
    },
    {
      value: "lives_with_children",
      label: "חי עם ילדים",
    },
    {
      value: "local_id_number",
      label: "מספר זיהוי מקומי",
    },
    {
      value: "max_monthly_hours",
      label: "שעות חודשיות מקסימליות",
    },
    {
      value: "monthly_transportation_cost_id",
      label: "מזהה עלות תחבורה חודשית",
    },
    {
      value: "mother_name",
      label: "שם אם",
    },
    {
      value: "non_available_hours",
      label: "שעות לא זמינות",
    },
    {
      value: "ok2go_revaha_employee_status",
      label: "סטטוס עובד OK2GO",
    },
    {
      value: "ok2go_status_id",
      label: "מזהה סטטוס OK2GO",
    },
    {
      value: "ok2go_status.clientEmployeeId",
      label: "מזהה עובד לקוח (סטטוס OK2GO)",
    },
    {
      value: "ok2go_status.employeeId",
      label: "מזהה עובד (סטטוס OK2GO)",
    },
    {
      value: "ok2go_status.ok2goEmployeeId",
      label: "מזהה עובד OK2GO (סטטוס OK2GO)",
    },
    {
      value: "ok2go_status.updatedAt",
      label: "עודכן בתאריך (סטטוס OK2GO)",
    },
    {
      value: "oncall",
      label: "כוננות",
    },
    {
      value: "oncall_hours",
      label: "שעות כוננות",
    },
    {
      value: "origin_religion_id",
      label: "מזהה דת מקורית",
    },
    {
      value: "other_income_source",
      label: "מקור הכנסה אחרת",
    },
    {
      value: "pay_transportation_costs_over_75",
      label: "תשלום עלות תחבורה מעל 67",
    },
    {
      value: "professional_role_id",
      label: "מזהה תפקיד מקצועי",
    },
    {
      value: "professional_role_position_percentage",
      label: "אחוז משרה בתפקיד מקצועי",
    },
    {
      value: "professional_trustee",
      label: "נאמן מקצועי",
    },
    {
      value: "qualifications.courses",
      label: "קורסים (הכשרות)",
    },
    {
      value: "qualifications.education",
      label: "השכלה (הכשרות)",
    },
    {
      value: "qualifications.professions",
      label: "מקצועות (הכשרות)",
    },
    {
      value: "qualifications.work_experience",
      label: "ניסיון עבודה (הכשרות)",
    },
    {
      value: "registered_by",
      label: "נרשם על ידי",
    },
    {
      value: "relatives",
      label: "קרובי משפחה",
    },
    {
      value: "religion_id",
      label: "מזהה דת",
    },
    {
      value: "religious",
      label: "דתי",
    },
    {
      value: "rest_day",
      label: "יום מנוחה",
    },
    {
      value: "salary_branch_id",
      label: "מזהה סניף שכר",
    },
    {
      value: "weekly_plan",
      label: "תכנית שבועית",
    },
    {
      value: "salary_branch.accounting_number_tag",
      label: "תג מספר חשבון (סניף שכר)",
    },
    {
      value: "salary_branch.address.apartment_number",
      label: "מספר דירה (כתובת סניף שכר)",
    },
    {
      value: "salary_branch.address.city",
      label: "עיר (כתובת סניף שכר)",
    },
    {
      value: "salary_branch.address.house_number",
      label: "מספר בית (כתובת סניף שכר)",
    },
    {
      value: "salary_branch.address.postal_code",
      label: "מיקוד (כתובת סניף שכר)",
    },
    {
      value: "salary_branch.address.street",
      label: "רחוב (כתובת סניף שכר)",
    },
    {
      value: "salary_branch.btl_accounting_number",
      label: "מספר חשבון ביטוח לאומי (סניף שכר)",
    },
    {
      value: "salary_branch.clients",
      label: "לקוחות (סניף שכר)",
    },
    {
      value: "salary_branch.created_at",
      label: "נוצר בתאריך (סניף שכר)",
    },
    {
      value: "salary_branch.credit_account_number",
      label: "מספר חשבון אשראי (סניף שכר)",
    },
    {
      value: "salary_branch.day_center_accounting_number",
      label: "מספר חשבון מרכז יום (סניף שכר)",
    },
    {
      value: "salary_branch.email",
      label: "אימייל (סניף שכר)",
    },
    {
      value: "salary_branch.extensions",
      label: "שלוחות (סניף שכר)",
    },
    {
      value: "salary_branch.fax_number",
      label: "מספר פקס (סניף שכר)",
    },
    {
      value: "salary_branch.group",
      label: "קבוצה (סניף שכר)",
    },
    {
      value: "salary_branch.group_id",
      label: "מזהה קבוצה (סניף שכר)",
    },
    {
      value: "salary_branch.id",
      label: "מזהה סניף שכר",
    },
    {
      value: "salary_branch.mailbox_number",
      label: "מספר תיבת דואר (סניף שכר)",
    },
    {
      value: "salary_branch.mobile_number",
      label: "מספר נייד (סניף שכר)",
    },
    {
      value: "salary_branch.name",
      label: "שם (סניף שכר)",
    },
    {
      value: "salary_branch.ok2go_code",
      label: "קוד OK2GO (סניף שכר)",
    },
    {
      value: "salary_branch.ok2go_password",
      label: "סיסמת OK2GO (סניף שכר)",
    },
    {
      value: "salary_branch.ok2go_revaha_code",
      label: "קוד OK2GO רווחה (סניף שכר)",
    },
    {
      value: "salary_branch.phone_number",
      label: "מספר טלפון (סניף שכר)",
    },
    {
      value: "salary_branch.salary_id",
      label: "מזהה שכר (סניף שכר)",
    },
    {
      value: "salary_branch.service_areas",
      label: "אזורים שירותיים (סניף שכר)",
    },
    {
      value: "salary_branch.subprojects",
      label: "תת-פרויקטים (סניף שכר)",
    },
    {
      value: "salary_branch.supporting_community_accounting_number",
      label: "מספר חשבון קהילה תומכת (סניף שכר)",
    },
    {
      value: "salary_branch.updated_at",
      label: "עודכן בתאריך (סניף שכר)",
    },
    {
      value: "service_areas",
      label: "אזורים שירותיים",
    },
    {
      value: "signature",
      label: "חתימה",
    },
    {
      value: "signature_id",
      label: "מזהה חתימה",
    },
    {
      value: "spouce_info.birthday",
      label: "תאריך לידה (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.first_name",
      label: "שם פרטי (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.health_fund",
      label: "קופת חולים (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.immigration_date",
      label: "תאריך הגירה (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.local_id",
      label: "מספר זיהוי מקומי (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.other_income_source",
      label: "מקור הכנסה אחרת (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.passport_number",
      label: "מספר דרכון",
    },
    {
      value: "spouce_info.phone_number",
      label: "מספר טלפון (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.surename",
      label: "שם משפחה (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.total_income",
      label: "הכנסה כוללת (מידע בן/בת זוג)",
    },
    {
      value: "spouce_info.total_income_required_tax",
      label: "הכנסה כוללת חייבת במס (מידע בן/בת זוג)",
    },
    {
      value: "staff_member",
      label: "חבר צוות",
    },
    {
      value: "staff_worker_in_charge_id",
      label: "מזהה עובד אחראי",
    },
    {
      value: "staff_worker_in_charge.accounting_info.department",
      label: "מחלקה (מידע חשבונאי, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.accounting_info.department_id",
      label: "מזהה מחלקה (מידע חשבונאי, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.accounting_info.number",
      label: "מספר חשבון (מידע חשבונאי, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.active_branches",
      label: "סניפים פעילים (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.address.apartment_number",
      label: "מספר דירה (כתובת, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.address.city",
      label: "עיר (כתובת, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.address.house_number",
      label: "מספר בית (כתובת, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.address.postal_code",
      label: "מיקוד (כתובת, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.address.street",
      label: "רחוב (כתובת, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.avatar_url",
      label: "כתובת תמונת פרופיל (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.bank_acccount.bank_id",
      label: "מזהה בנק (חשבון בנק, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.bank_acccount.branch_id",
      label: "מזהה סניף (חשבון בנק, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.bank_acccount.number",
      label: "מספר חשבון (חשבון בנק, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.birthday",
      label: "תאריך לידה (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.branch_active",
      label: "סניף פעיל (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.care_demands",
      label: "דרישות טיפול (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.certified_courses",
      label: "קורסים מוסמכים (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.children",
      label: "ילדים (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.agree_to_receive_email",
      label: "הסכמה לקבלת אימייל (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.agree_to_receive_sms",
      label: "הסכמה לקבלת SMS (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.email",
      label: "אימייל (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.fax_number",
      label: "מספר פקס (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.mailbox_number",
      label: "מספר תיבת דואר (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.mobile_number",
      label: "מספר נייד (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.phone_number",
      label: "מספר טלפון (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.contact_info.phone_number2",
      label: "מספר טלפון נוסף (פרטי התקשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.created_at",
      label: "נוצר בתאריך (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.employee_type_id",
      label: "מזהה סוג עובד (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.exported_at",
      label: "יוצא בתאריך (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.family_status",
      label: "סטטוס משפחתי (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.father_name",
      label: "שם אב (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.first_name",
      label: "שם פרטי (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.address",
      label: "כתובת (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.address",
      label: "כתובת (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.branch_name",
      label: "שם סניף (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.branch_symbol",
      label: "סמל סניף (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.country",
      label: "מדינה (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.first_name",
      label: "שם פרטי (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.name",
      label: "שם (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.number",
      label: "מספר חשבון (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.surname",
      label: "שם משפחה (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.swift_code",
      label: "קוד SWIFT (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.bank_account.symbol",
      label: "סמל (חשבון בנק זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.country_enter_date",
      label: "תאריך כניסה למדינה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.current_corporation_id",
      label: "מזהה תאגיד נוכחי (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.current_corporation_registry_date",
      label: "תאריך רישום תאגיד נוכחי (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.deposit_acccount.bank_id",
      label: "מזהה בנק (חשבון פיקדון זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.deposit_acccount.branch_id",
      label: "מזהה סניף (חשבון פיקדון זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.deposit_acccount.number",
      label: "מספר חשבון (חשבון פיקדון זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.employment_license_expiration",
      label: "תאריך תפוגת רישיון עבודה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.employment_license_number",
      label: "מספר רישיון עבודה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.exited_country_at",
      label: "תאריך יציאה מהמדינה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.father_name",
      label: "שם אב (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.file_issued",
      label: "קובץ הונפק (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.file_issued_at",
      label: "תאריך הנפקת קובץ (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.first_name",
      label: "שם פרטי (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.has_assignment_letter",
      label: "יש מכתב משימה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.insurance_company_id",
      label: "מזהה חברת ביטוח (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.insurance_company.description",
      label: "תיאור חברת ביטוח (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.insurance_company.id",
      label: "מזהה חברת ביטוח (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.insurance_company.name",
      label: "שם חברת ביטוח (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.interior_ministry_case_number",
      label: "מספר תיק במשרד הפנים (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.medical_insurance_expired_at",
      label: "תאריך תפוגת ביטוח רפואי (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.mother_name",
      label: "שם אם (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.origin_country",
      label: "מדינת מוצא (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.partner_in_country",
      label: "שותף במדינה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.passport_expired_at",
      label: "תאריך תפוגת דרכון (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.passport_number",
      label: "מספר דרכון (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.previous_corporation_id",
      label: "מזהה תאגיד קודם (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.registered_in_employer_service",
      label: "רשום בשירות מעסיקים (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.surename",
      label: "שם משפחה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.tourist_with_license",
      label: "תייר עם רישיון (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.visa_expired_at",
      label: "תאריך תפוגת ויזה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.foreign.visa_number",
      label: "מספר ויזה (מידע זר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.gender_id",
      label: "מזהה מגדר (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.geo",
      label: "מיקום גיאוגרפי (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.has_other_income",
      label: "יש הכנסה נוספת (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.health_fund",
      label: "קופת חולים (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.id",
      label: "מזהה עובד אחראי",
    },
    {
      value: "staff_worker_in_charge.israeli_resident",
      label: "תושב ישראלי (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.languages",
      label: "שפות (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.lives_with_children",
      label: "חי עם ילדים (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.local_id_number",
      label: "מספר זיהוי מקומי (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.max_monthly_hours",
      label: "שעות חודשיות מקסימליות (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.mother_name",
      label: "שם אם (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.ok2go_revaha_employee_status",
      label: "סטטוס עובד OK2GO (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.ok2go_status",
      label: "סטטוס OK2GO (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.ok2go_status_id",
      label: "מזהה סטטוס OK2GO (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.origin_religion_id",
      label: "מזהה דת מקורית (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.qualifications.courses",
      label: "קורסים (הכשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.qualifications.education",
      label: "השכלה (הכשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.qualifications.professions",
      label: "מקצועות (הכשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.qualifications.work_experience",
      label: "ניסיון עבודה (הכשרות, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.registered_by",
      label: "נרשם על ידי (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.religion_id",
      label: "מזהה דת (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch_id",
      label: "מזהה סניף שכר (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.accounting_number_tag",
      label: "תג מספר חשבון (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.address.apartment_number",
      label: "מספר דירה (כתובת סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.address.city",
      label: "עיר (כתובת סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.address.house_number",
      label: "מספר בית (כתובת סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.address.postal_code",
      label: "מיקוד (כתובת סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.address.street",
      label: "רחוב (כתובת סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.btl_accounting_number",
      label: "מספר חשבון ביטוח לאומי (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.clients",
      label: "לקוחות (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.created_at",
      label: "נוצר בתאריך (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.credit_account_number",
      label: "מספר חשבון אשראי (סניף שכר, עובד אחראי)",
    },
    {
      value:
        "staff_worker_in_charge.salary_branch.day_center_accounting_number",
      label: "מספר חשבון מרכז יום (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.email",
      label: "אימייל (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.extensions",
      label: "שלוחות (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.fax_number",
      label: "מספר פקס (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.group",
      label: "קבוצה (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.group_id",
      label: "מזהה קבוצה (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.id",
      label: "מזהה סניף שכר (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.mailbox_number",
      label: "מספר תיבת דואר (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.mobile_number",
      label: "מספר נייד (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.name",
      label: "שם (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.ok2go_code",
      label: "קוד OK2GO (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.ok2go_password",
      label: "סיסמת OK2GO (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.ok2go_revaha_code",
      label: "קוד OK2GO רווחה (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.phone_number",
      label: "מספר טלפון (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.salary_id",
      label: "מזהה שכר (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.service_areas",
      label: "אזורים שירותיים (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.subprojects",
      label: "תת-פרויקטים (סניף שכר, עובד אחראי)",
    },
    {
      value:
        "staff_worker_in_charge.salary_branch.supporting_community_accounting_number",
      label: "מספר חשבון קהילה תומכת (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.salary_branch.updated_at",
      label: "עודכן בתאריך (סניף שכר, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.signature",
      label: "חתימה (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.signature_id",
      label: "מזהה חתימה (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.birthday",
      label: "תאריך לידה (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.first_name",
      label: "שם פרטי (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.health_fund",
      label: "קופת חולים (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.immigration_date",
      label: "תאריך הגירה (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.local_id",
      label: "מספר זיהוי מקומי (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.phone_number",
      label: "מספר טלפון (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.surename",
      label: "שם משפחה (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.total_income",
      label: "הכנסה כוללת (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.spouce_info.total_income_required_tax",
      label: "הכנסה כוללת חייבת במס (מידע בן/בת זוג, עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.surename",
      label: "שם משפחה (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.updated_at",
      label: "עודכן בתאריך (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.work_period_status",
      label: "סטטוס תקופת עבודה (עובד אחראי)",
    },
    {
      value: "staff_worker_in_charge.youth_name",
      label: "שם נעורים (עובד אחראי)",
    },
    {
      value: "status",
      label: "סטטוס",
    },
    {
      value: "surename",
      label: "שם משפחה",
    },
    {
      value: "tariff",
      label: "תעריף",
    },
    {
      value: "tariff_id",
      label: "מזהה תעריף",
    },
    {
      value: "tariff.active",
      label: "פעיל (תעריף)",
    },
    {
      value: "tariff.cost",
      label: "עלות תעריף",
    },
    {
      value: "tariff.description",
      label: "תיאור תעריף",
    },
    {
      value: "tariff.id",
      label: "מזהה תעריף",
    },
    {
      value: "tariff.is_default",
      label: "ברירת מחדל (תעריף)",
    },
    {
      value: "tariff.name",
      label: "שם תעריף",
    },
    {
      value: "tariff.tariff_versions",
      label: "גרסאות תעריף",
    },
    {
      value: "transportation_cost_strategy",
      label: "אסטרטגיית עלות תחבורה",
    },
    {
      value: "updated_at",
      label: "עודכן בתאריך",
    },
    {
      value: "work_in_other_company",
      label: "עובד בחברה אחרת",
    },
    {
      value: "work_period_status",
      label: "סטטוס תקופת עבודה",
    },
    {
      value: "work_periods",
      label: "תקופות עבודה",
    },
    {
      value: "working_start_dates.2021",
      label: "תחילת עבודה (2021)",
    },
    {
      value: "working_start_dates.2022",
      label: "תחילת עבודה (2022)",
    },
    {
      value: "working_start_dates.2023",
      label: "תחילת עבודה (2023)",
    },
    {
      value: "working_start_dates.2024",
      label: "תחילת עבודה (2024)",
    },
    {
      value: "working_start_dates.2025",
      label: "תחילת עבודה (2025)",
    },
    {
      value: "youth_name",
      label: "שם נעורים",
    },
  ]),

  company: sortMappings([
    {
      value: "accounting_export_type",
      label: "סוג ייצוא חשבונאי",
    },
    {
      value: "accounting_export.active",
      label: "ייצוא חשבונאי פעיל",
    },
    {
      value: "accounting_export.daily_sync_time",
      label: "זמן סנכרון יומי לייצוא חשבונאי",
    },
    {
      value: "accounting_export.dir_per_branch",
      label: "תיקייה לכל סניף לייצוא חשבונאי",
    },
    {
      value: "accounting_export.ftp_address",
      label: "כתובת FTP לייצוא חשבונאי",
    },
    {
      value: "accounting_export.ftp_password",
      label: "סיסמת FTP לייצוא חשבונאי",
    },
    {
      value: "accounting_export.ftp_user",
      label: "משתמש FTP לייצוא חשבונאי",
    },
    {
      value: "accounting_export.input_dir",
      label: "תיקיית קלט לייצוא חשבונאי",
    },
    {
      value: "accounting_export.output_dir",
      label: "תיקיית פלט לייצוא חשבונאי",
    },
    {
      value: "accounting_export.processed_input_dir",
      label: "תיקיית קלט מעובדת לייצוא חשבונאי",
    },
    {
      value: "address_details",
      label: "כתובת מלאה",
    },
    {
      value: "address.apartment_number",
      label: "מספר דירה (כתובת)",
    },
    {
      value: "address.city",
      label: "עיר (כתובת)",
    },
    {
      value: "address.house_number",
      label: "מספר בית (כתובת)",
    },
    {
      value: "address.postal_code",
      label: "מיקוד (כתובת)",
    },
    {
      value: "address.street",
      label: "רחוב (כתובת)",
    },
    {
      value: "allow_diaries_upfront_approval",
      label: "אישור מראש ליומנים",
    },
    {
      value: "allow_hours_overloading",
      label: "אישור עומס שעות",
    },
    {
      value: "auto_login_days",
      label: "ימים להתחברות אוטומטית",
    },
    {
      value: "avatar_url",
      label: "לוגו",
    },
    {
      value: "current_date",
      label: "תאריך נוכחי",
    },
    {
      value: "day_center_tariffs",
      label: "תעריפי מרכז יום",
    },
    {
      value: "days_between_house_visits",
      label: "ימים בין ביקורי בית",
    },
    {
      value: "email",
      label: "אימייל",
    },
    {
      value: "employee_export_type",
      label: "סוג ייצוא עובד",
    },
    {
      value: "employee_max_monthly_hours",
      label: "מקסימום שעות חודשיות לעובד",
    },
    {
      value: "employees_sync.active",
      label: "סנכרון עובדים פעיל",
    },
    {
      value: "employees_sync.daily_sync_time",
      label: "זמן סנכרון יומי לסנכרון עובדים",
    },
    {
      value: "employees_sync.dir_per_branch",
      label: "תיקייה לכל סניף לסנכרון עובדים",
    },
    {
      value: "employees_sync.ftp_address",
      label: "כתובת FTP לסנכרון עובדים",
    },
    {
      value: "employees_sync.ftp_password",
      label: "סיסמת FTP לסנכרון עובדים",
    },
    {
      value: "employees_sync.ftp_user",
      label: "משתמש FTP לסנכרון עובדים",
    },
    {
      value: "employees_sync.input_dir",
      label: "תיקיית קלט לסנכרון עובדים",
    },
    {
      value: "employees_sync.output_dir",
      label: "תיקיית פלט לסנכרון עובדים",
    },
    {
      value: "employees_sync.processed_input_dir",
      label: "תיקיית קלט מעובדת לסנכרון עובדים",
    },
    {
      value: "fax_number",
      label: "מספר פקס",
    },
    {
      value: "features",
      label: "תכונות",
    },
    {
      value: "foreign_auto_vacation_per_month",
      label: "חופשה אוטומטית לעובדים זרים לחודש",
    },
    {
      value: "foreign_pay_extra_hours",
      label: "תשלום שעות נוספות לעובדים זרים",
    },
    {
      value: "foreign_pay_holiday_hours",
      label: "תשלום שעות חופשה לעובדים זרים",
    },
    {
      value: "foreign_pay_vacation_hours",
      label: "תשלום שעות חופשה לעובדים זרים",
    },
    {
      value: "foreign_worker_association_id",
      label: "מזהה עמותת עובדים זרים",
    },
    {
      value: "generate_replacement_on_holiday",
      label: "יצירת תחליף בחופשה",
    },
    {
      value: "id",
      label: "מזהה",
    },
    {
      value: "max_holiday_hours_pay_day",
      label: "מקסימום שעות חופשה ביום",
    },
    {
      value: "max_vacation_hours_pay_day",
      label: "מקסימום שעות חופשה ביום",
    },
    {
      value: "min_holiday_salary_seniority",
      label: "וותק מינימלי לשכר חופשה",
    },
    {
      value: "mobile",
      label: "מספר נייד",
    },
    {
      value: "months_between_house_visits",
      label: "חודשים בין ביקורי בית",
    },
    {
      value: "name",
      label: "שם",
    },
    {
      value: "ok2go_api_url",
      label: "כתובת API של OK2GO",
    },
    {
      value: "ok2go_password",
      label: "סיסמת OK2GO",
    },
    {
      value: "ok2go_revaha_service_types",
      label: "סוגי שירות OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.active",
      label: "סנכרון OK2GO רווחה פעיל",
    },
    {
      value: "ok2go_revaha_sync.daily_sync_time",
      label: "זמן סנכרון יומי לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.dir_per_branch",
      label: "תיקייה לכל סניף לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.ftp_address",
      label: "כתובת FTP לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.ftp_password",
      label: "סיסמת FTP לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.ftp_user",
      label: "משתמש FTP לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.input_dir",
      label: "תיקיית קלט לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.output_dir",
      label: "תיקיית פלט לסנכרון OK2GO רווחה",
    },
    {
      value: "ok2go_revaha_sync.processed_input_dir",
      label: "תיקיית קלט מעובדת לסנכרון OK2GO רווחה",
    },
    {
      value: "patients_export.active",
      label: "ייצוא מטופלים פעיל",
    },
    {
      value: "patients_export.daily_sync_time",
      label: "זמן סנכרון יומי לייצוא מטופלים",
    },
    {
      value: "patients_export.dir_per_branch",
      label: "תיקייה לכל סניף לייצוא מטופלים",
    },
    {
      value: "patients_export.ftp_address",
      label: "כתובת FTP לייצוא מטופלים",
    },
    {
      value: "patients_export.ftp_password",
      label: "סיסמת FTP לייצוא מטופלים",
    },
    {
      value: "patients_export.ftp_user",
      label: "משתמש FTP לייצוא מטופלים",
    },
    {
      value: "patients_export.input_dir",
      label: "תיקיית קלט לייצוא מטופלים",
    },
    {
      value: "patients_export.output_dir",
      label: "תיקיית פלט לייצוא מטופלים",
    },
    {
      value: "patients_export.processed_input_dir",
      label: "תיקיית קלט מעובדת לייצוא מטופלים",
    },
    {
      value: "pay_transportation_costs_to_foreign",
      label: "תשלום עלות תחבורה לעובדים זרים",
    },
    {
      value: "phone_number",
      label: "מספר טלפון",
    },
    {
      value: "phone_number2",
      label: "מספר טלפון נוסף",
    },
    {
      value: "prospectus_export.active",
      label: "ייצוא תשקיף פעיל",
    },
    {
      value: "prospectus_export.daily_sync_time",
      label: "זמן סנכרון יומי לייצוא תשקיף",
    },
    {
      value: "prospectus_export.dir_per_branch",
      label: "תיקייה לכל סניף לייצוא תשקיף",
    },
    {
      value: "prospectus_export.ftp_address",
      label: "כתובת FTP לייצוא תשקיף",
    },
    {
      value: "prospectus_export.ftp_password",
      label: "סיסמת FTP לייצוא תשקיף",
    },
    {
      value: "prospectus_export.ftp_user",
      label: "משתמש FTP לייצוא תשקיף",
    },
    {
      value: "prospectus_export.input_dir",
      label: "תיקיית קלט לייצוא תשקיף",
    },
    {
      value: "prospectus_export.output_dir",
      label: "תיקיית פלט לייצוא תשקיף",
    },
    {
      value: "prospectus_export.processed_input_dir",
      label: "תיקיית קלט מעובדת לייצוא תשקיף",
    },
    {
      value: "revaha_service_provider_number",
      label: "מספר ספק שירות רווחה",
    },
    {
      value: "salary_export_id",
      label: "מזהה ייצוא שכר",
    },
    {
      value: "salary_export_type",
      label: "סוג ייצוא שכר",
    },
    {
      value: "salary_export_type_id",
      label: "מזהה סוג ייצוא שכר",
    },
    {
      value: "salary_export.active",
      label: "ייצוא שכר פעיל",
    },
    {
      value: "salary_export.daily_sync_time",
      label: "זמן סנכרון יומי לייצוא שכר",
    },
    {
      value: "salary_export.dir_per_branch",
      label: "תיקייה לכל סניף לייצוא שכר",
    },
    {
      value: "salary_export.ftp_address",
      label: "כתובת FTP לייצוא שכר",
    },
    {
      value: "salary_export.ftp_password",
      label: "סיסמת FTP לייצוא שכר",
    },
    {
      value: "salary_export.ftp_user",
      label: "משתמש FTP לייצוא שכר",
    },
    {
      value: "salary_export.input_dir",
      label: "תיקיית קלט לייצוא שכר",
    },
    {
      value: "salary_export.output_dir",
      label: "תיקיית פלט לייצוא שכר",
    },
    {
      value: "salary_export.processed_input_dir",
      label: "תיקיית קלט מעובדת לייצוא שכר",
    },
    {
      value: "send_sms_on_finish_house_visit",
      label: "שליחת SMS בסיום ביקור בית",
    },
    {
      value: "service_provider_number",
      label: "מספר ספק שירות",
    },
    {
      value: "smtp_email",
      label: "אימייל SMTP",
    },
    {
      value: "smtp_password",
      label: "סיסמת SMTP",
    },
    {
      value: "smtp_port",
      label: "פורט SMTP",
    },
    {
      value: "smtp_server",
      label: "שרת SMTP",
    },
    {
      value: "supporting_community_client_tariff",
      label: "תעריף לקוח קהילה תומכת",
    },
    {
      value: "supporting_community_client_tariff_id",
      label: "מזהה תעריף לקוח קהילה תומכת",
    },
    {
      value: "supporting_community_service_provider_number",
      label: "מספר ספק שירות קהילה תומכת",
    },
    {
      value: "tax_id",
      label: "מזהה מס",
    },
    {
      value: "time_watch_company_id",
      label: "מזהה חברת שעון זמן",
    },
    {
      value: "type",
      label: "סוג",
    },
    {
      value: "type_id",
      label: "מזהה סוג",
    },
    {
      value: "unify_salary_symbols",
      label: "איחוד סמלי שכר",
    },
    {
      value: "vat_account_number",
      label: "מספר חשבון מעמ",
    },
    {
      value: "income_tax_deduction_protfolio_101",
      label: "תיק ניכויים מס הכנסה",
    },
    {
      value: "zero_transportation_costs_over_75",
      label: "אפס עלות תחבורה מעל 67",
    },
  ]),
};
